import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"
import React from "react"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import FieldSelect from "../../Table/FieldSelect"
import { useBeautyModalStyle } from "./style"
import { useUpdate } from "./hooks"

const Update = () => {
    const classes = useBeautyModalStyle()
    const {
        callback, cancelCallback, dialogData,
        disabled, dateStr, text, handleChange, handleChangeArticleType, external
    } = useUpdate()
    return (
        <BoardConfirmModal
            title="修改预约说明1"
            confirmCallback={callback}
            cancelCallback={cancelCallback}
            modalShow={dialogData.show}
            disabled={disabled}
        >
            <Grid container direction="column" justify="center">
                <div>{dateStr}</div>
                <TextField
                    label="预约说明"
                    value={text}
                    onChange={handleChange}
                />
            </Grid>

            <Grid item>
                <FormControl className={classes.input}>
                    <InputLabel >文章类型</InputLabel>
                    <FieldSelect
                        rowData={{
                            beauty_article_type_id: external.articleTypeId,
                        }}
                        staticValueList={[]}
                        tableName="beauty_article_type"
                        onChange={handleChangeArticleType}
                        whereQuery={"where: {hidden: {_eq: false}}"}
                    />
                </FormControl>
            </Grid>
        </BoardConfirmModal>
    )
}

export default Update
